import { withTheme } from '../config';
import { AirbnbRating, } from '@rneui/base/dist/AirbnbRating/index';
export { AirbnbRating };
export const AirbnbRatingDefault = withTheme(AirbnbRating, 'AirbnbRating');
